module.exports = "./img/c238614e9fccab4761d948922e728842.jpg";